/**
 * GA4 / GTM dataLayer event helper for sohl-id.com
 * Container: GTM-PNDLD9HS
 *
 * Hooks into Dawn's PubSub for cart changes and observes <cart-drawer> open state.
 * Fires: add_to_cart, remove_from_cart, view_cart, begin_checkout
 * Does NOT monkey-patch window.fetch.
 */
(function () {
  'use strict';

  function push(eventName, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: eventName, ecommerce: ecommerce });
  }

  function itemFromCart(item) {
    return {
      item_id: item.sku || String(item.variant_id),
      item_name: item.product_title,
      item_brand: item.vendor,
      item_category: item.product_type || '',
      item_variant: item.variant_title,
      price: (item.final_price != null ? item.final_price : item.price) / 100,
      quantity: item.quantity
    };
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // ---------- CART DIFF (add_to_cart + remove_from_cart) ----------
  var prevCart = null;
  fetchCart().then(function (c) { prevCart = c; }).catch(function () {});

  function diffAndPush(currentCart) {
    if (!prevCart) { prevCart = currentCart; return; }

    // Additions / quantity increases
    for (var i = 0; i < currentCart.items.length; i++) {
      var c = currentCart.items[i];
      var prev = prevCart.items.find(function (p) { return p.key === c.key; });
      if (!prev) {
        push('add_to_cart', {
          currency: currentCart.currency,
          value: ((c.final_price != null ? c.final_price : c.price) * c.quantity) / 100,
          items: [itemFromCart(c)]
        });
      } else if (c.quantity > prev.quantity) {
        var added = Object.assign({}, c, { quantity: c.quantity - prev.quantity });
        push('add_to_cart', {
          currency: currentCart.currency,
          value: ((c.final_price != null ? c.final_price : c.price) * added.quantity) / 100,
          items: [itemFromCart(added)]
        });
      }
    }

    // Removals / quantity decreases
    for (var j = 0; j < prevCart.items.length; j++) {
      var p = prevCart.items[j];
      var curr = currentCart.items.find(function (cc) { return cc.key === p.key; });
      if (!curr) {
        push('remove_from_cart', {
          currency: (currentCart.currency || p.currency || 'USD'),
          value: ((p.final_price != null ? p.final_price : p.price) * p.quantity) / 100,
          items: [itemFromCart(p)]
        });
      } else if (curr.quantity < p.quantity) {
        var removed = Object.assign({}, p, { quantity: p.quantity - curr.quantity });
        push('remove_from_cart', {
          currency: currentCart.currency,
          value: ((p.final_price != null ? p.final_price : p.price) * removed.quantity) / 100,
          items: [itemFromCart(removed)]
        });
      }
    }

    prevCart = currentCart;
  }

  // Hook into Dawn's PubSub (available via pubsub.js in theme.liquid)
  function hookPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // Dawn not ready yet — retry shortly
      setTimeout(hookPubSub, 250);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetchCart().then(diffAndPush).catch(function () {});
    });
  }
  hookPubSub();

  // ---------- VIEW CART (drawer open) ----------
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      // DOM not ready — retry
      setTimeout(watchDrawer, 250);
      return;
    }

    var observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type !== 'attributes' || m.attributeName !== 'class') continue;
        var isActive = drawer.classList.contains('active');
        if (isActive && !drawer.__gtmViewCartFired) {
          drawer.__gtmViewCartFired = true;
          fetchCart().then(function (cart) {
            if (!cart.items || !cart.items.length) return;
            push('view_cart', {
              currency: cart.currency,
              value: cart.total_price / 100,
              items: cart.items.map(itemFromCart)
            });
          }).catch(function () {});
        } else if (!isActive) {
          drawer.__gtmViewCartFired = false;
        }
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  // ---------- BEGIN CHECKOUT ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!btn) return;
    // Fire synchronously-ish — we can't block navigation, but fetch is usually fast enough
    // Use keepalive for reliability if navigation interrupts
    fetchCart().then(function (cart) {
      if (!cart.items || !cart.items.length) return;
      push('begin_checkout', {
        currency: cart.currency,
        value: cart.total_price / 100,
        items: cart.items.map(itemFromCart)
      });
    }).catch(function () {});
  }, true); // capture phase so we fire before other handlers
})();
